import { ref } from 'vue';
import { MediaUtils } from '@/pixel/index';

import Tracking from '@/components/commons/Tracking.js';
import { scrollTop, executeMutation } from '@/components/commons/utils.js';
import { trackProductAddToCart } from '@/compositions/useFilterProduct';
import { animateAddCart } from './animateAddCart.js';
import { gql } from '@apollo/client/core';
import Chat from '@/components/commons/Chat.js';

export function parseProducts(products) {
  return products.map((product) => ({ productId: Number.parseInt(product.id, 10), quantity: product.quantity }));
}

async function addCart(products) {
  const items = parseProducts(products);

  await executeMutation(
    gql`
      mutation ADD_ITEMS_TO_CART($items: [CartItemInput]) {
        addItemsToCart(items: $items) {
          success
        }
      }
    `,
    { items },
  );
}

export default function useAddToCart() {
  const isAddingCart = ref(false);

  function toggleAddingCart() {
    isAddingCart.value = !isAddingCart.value;
  }

  async function addCartProcess({ products, buttonToAnimate = null, scrollFirst = false }) {
    scrollFirst && scrollTop();
    toggleAddingCart();

    try {
      if (!MediaUtils.isTabletAndSmaller && buttonToAnimate) {
        await Promise.all([addCart(products), animateAddCart(buttonToAnimate)]);
      } else {
        await addCart(products);
      }
    } catch (error) {
      console.error(error);
      Tracking.sentryCaptureError(error);
    }

    toggleAddingCart();
    Chat.hideChatWindow();

    try {
      // Only send Algolia events when adding single product to cart, sets are not supported
      if (products && products.length === 1) {
        trackProductAddToCart(products[0].id);
      }
    } catch (e) {
      Tracking.sentryCaptureError(e);
    }
  }

  return {
    isAddingCart,
    addCartProcess,
  };
}
